// /src/pages/6bannersolution.jsx
// VERSÃO 1.0 SUPREMA - BANNER ENGINE (TIM UNITY EDITION)

import React, { useState } from 'react';
import MainLayout from '../components/layout/MainLayout';
import { 
    FiUpload, FiTrash2, FiSave, FiImage, 
    FiLink, FiLayers, FiType, FiZap, FiLayout, FiX, FiCheckCircle
} from 'react-icons/fi';
import { toast } from 'react-toastify';
import apiClient from '../api/apiClient';

// ==========================================================
// 🛡️ COMPONENTE: UPLOAD DE BANNER ELITE
// ==========================================================
function BannerUploader({ file, onFileChange, onRemove }) {
    const resolveUrl = (f) => (typeof f === 'string' ? f : URL.createObjectURL(f));

    return (
        <div className="w-full space-y-6">
            {!file ? (
                <label className="w-full h-80 flex flex-col items-center justify-center border-4 border-dashed border-[var(--border-color)] rounded-[3rem] cursor-pointer transition-all group hover:border-accent hover:bg-accent/5">
                    <div className="w-20 h-20 rounded-3xl bg-accent/10 flex items-center justify-center text-accent mb-4 group-hover:scale-110 transition-transform">
                        <FiUpload size={40} />
                    </div>
                    <span className="text-[10px] font-black uppercase tracking-[0.4em] text-auto opacity-40">Injetar Mídia do Banner</span>
                    <p className="text-[8px] font-bold uppercase tracking-widest text-sec-auto mt-2 text-center opacity-30">
                        Recomendado: 1920x600px (Desktop) <br/> 800x800px (Mobile)
                    </p>
                    <input type="file" className="hidden" onChange={(e) => onFileChange(e.target.files[0])} accept="image/*" />
                </label>
            ) : (
                <div className="relative w-full h-80 rounded-[3rem] overflow-hidden border border-[var(--border-color)] shadow-2xl group">
                    <img src={resolveUrl(file)} className="w-full h-full object-cover" alt="Preview Banner" />
                    <div className="absolute inset-0 bg-black/60 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-all flex items-center justify-center gap-4">
                        <button onClick={onRemove} className="p-6 rounded-full bg-red-600/20 text-red-500 hover:bg-red-600 hover:text-white transition-all shadow-xl border border-red-500/20">
                            <FiTrash2 size={24} />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

// ==========================================================
// 🚀 PÁGINA PRINCIPAL: 6BANNERSOLUTION
// ==========================================================
export default function BannerSolutionPage() {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        titulo: '',
        link: '',
        posicao: 'home_topo', // home_topo, home_meio, lateral
        status: 'Ativo',
        imagem: null
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (!formData.imagem) return toast.error("🚨 ERRO: Banner sem mídia detectado.");
        
        setIsSubmitting(true);
        try {
            const data = new FormData();
            data.append('titulo', formData.titulo);
            data.append('link', formData.link);
            data.append('posicao', formData.posicao);
            data.append('status', formData.status);
            data.append('banner', formData.imagem);

            await apiClient.post('/api/banners', data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            toast.success("🛡️ PROTOCOLO DE BANNER SINCRONIZADO!");
            setFormData({ titulo: '', link: '', posicao: 'home_topo', status: 'Ativo', imagem: null });
        } catch (err) {
            toast.error("💥 FALHA NO UPLINK: Verifique a conexão com o servidor.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <MainLayout>
            <div className="w-full max-w-[1400px] mx-auto space-y-12 p-8 md:p-16 animate-in fade-in duration-700">
                
                {/* HEADER OPERACIONAL */}
                <header className="flex flex-col md:flex-row justify-between items-start md:items-center border-b border-auto pb-12 gap-8">
                    <div className="flex items-center gap-8">
                        <div className="relative">
                            <div className="w-20 h-20 rounded-[2rem] bg-accent/10 border border-accent/20 flex items-center justify-center text-accent shadow-2xl">
                                <FiImage size={38} />
                            </div>
                            <div className="absolute -top-2 -right-2 w-8 h-8 bg-accent text-black rounded-full flex items-center justify-center font-black text-[12px] border-4 border-[var(--bg-main)]">
                                <FiZap size={14} />
                            </div>
                        </div>
                        <div>
                            <h1 className="text-4xl md:text-5xl font-black uppercase tracking-tighter text-auto leading-none">
                                Gestão de <span className="text-accent">Banners</span>
                            </h1>
                            <p className="text-[10px] font-black uppercase tracking-[0.5em] mt-3 opacity-40 text-auto">Sistema de Impacto Visual v1.0</p>
                        </div>
                    </div>
                </header>

                <form onSubmit={handleSave} className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    
                    {/* COLUNA ESQUERDA: CONFIGURAÇÕES */}
                    <div className="lg:col-span-5 space-y-8">
                        <div className="p-10 rounded-[3rem] border border-[var(--border-color)] bg-[var(--bg-card)] shadow-2xl space-y-8">
                            <h3 className="text-[11px] font-black uppercase tracking-[0.4em] text-accent flex items-center gap-3">
                                <FiLayout /> Detalhes táticos
                            </h3>

                            {/* Campo Título */}
                            <div className="space-y-3">
                                <label className="text-[9px] font-black uppercase tracking-widest opacity-40 ml-2">Título do Banner</label>
                                <div className="relative group">
                                    <FiType className="absolute left-5 top-1/2 -translate-y-1/2 text-accent opacity-40 group-focus-within:opacity-100 transition-all" />
                                    <input 
                                        name="titulo" value={formData.titulo} onChange={handleChange} required
                                        placeholder="Ex: Campanha 50GB Dobro"
                                        className="w-full bg-[var(--bg-main)] border border-auto rounded-2xl py-5 pl-14 pr-6 text-xs font-bold outline-none focus:border-accent transition-all shadow-inner"
                                    />
                                </div>
                            </div>

                            {/* Campo Link */}
                            <div className="space-y-3">
                                <label className="text-[9px] font-black uppercase tracking-widest opacity-40 ml-2">URL de Direcionamento</label>
                                <div className="relative group">
                                    <FiLink className="absolute left-5 top-1/2 -translate-y-1/2 text-accent opacity-40 group-focus-within:opacity-100 transition-all" />
                                    <input 
                                        name="link" value={formData.link} onChange={handleChange}
                                        placeholder="https://loja-tim.com.br/promo"
                                        className="w-full bg-[var(--bg-main)] border border-auto rounded-2xl py-5 pl-14 pr-6 text-xs font-bold outline-none focus:border-accent transition-all shadow-inner"
                                    />
                                </div>
                            </div>

                            {/* Posicionamento */}
                            <div className="grid grid-cols-2 gap-4">
                                <div className="space-y-3">
                                    <label className="text-[9px] font-black uppercase tracking-widest opacity-40 ml-2">Posição</label>
                                    <select 
                                        name="posicao" value={formData.posicao} onChange={handleChange}
                                        className="w-full bg-[var(--bg-main)] border border-auto rounded-2xl py-5 px-6 text-[10px] font-black uppercase outline-none focus:border-accent transition-all appearance-none cursor-pointer"
                                    >
                                        <option value="home_topo">Home - Topo</option>
                                        <option value="home_meio">Home - Meio</option>
                                        <option value="lateral">Sidebar Lateral</option>
                                        <option value="mobile_exclusivo">Mobile Only</option>
                                    </select>
                                </div>
                                <div className="space-y-3">
                                    <label className="text-[9px] font-black uppercase tracking-widest opacity-40 ml-2">Status</label>
                                    <select 
                                        name="status" value={formData.status} onChange={handleChange}
                                        className="w-full bg-[var(--bg-main)] border border-auto rounded-2xl py-5 px-6 text-[10px] font-black uppercase outline-none focus:border-accent transition-all appearance-none cursor-pointer"
                                    >
                                        <option value="Ativo">Publicado</option>
                                        <option value="Pendente">Rascunho</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* BOTÃO SALVAR */}
                        <button 
                            type="submit" disabled={isSubmitting}
                            className="w-full py-7 rounded-[2.5rem] bg-accent text-black font-black uppercase tracking-[0.4em] text-[12px] shadow-2xl flex items-center justify-center gap-4 hover:scale-[1.02] active:scale-95 transition-all disabled:opacity-50"
                        >
                            {isSubmitting ? <FiLayers className="animate-spin" /> : <FiCheckCircle size={20} />}
                            Finalizar Sincronia
                        </button>
                    </div>

                    {/* COLUNA DIREITA: MÍDIA (PREVIEW) */}
                    <div className="lg:col-span-7">
                        <div className="p-10 rounded-[4rem] border border-[var(--border-color)] bg-[var(--bg-card)] shadow-2xl space-y-10 h-full">
                            <div className="flex items-center justify-between">
                                <h3 className="text-[11px] font-black uppercase tracking-[0.4em] text-accent flex items-center gap-3">
                                    <FiImage /> Asset de Imagem
                                </h3>
                                <div className="px-4 py-1.5 rounded-full bg-accent/10 border border-accent/20 text-accent text-[8px] font-black uppercase animate-pulse">
                                    Aguardando Upload
                                </div>
                            </div>

                            <BannerUploader 
                                file={formData.imagem} 
                                onFileChange={(file) => setFormData(prev => ({ ...prev, imagem: file }))}
                                onRemove={() => setFormData(prev => ({ ...prev, imagem: null }))}
                            />

                            <div className="p-8 rounded-3xl border border-dashed border-accent/20 bg-accent/5 opacity-50">
                                <p className="text-[8px] font-black uppercase tracking-[0.3em] text-accent text-center leading-relaxed">
                                    POLÍTICA DE OTIMIZAÇÃO: UTILIZE ARQUIVOS JPG OU WEBP COM COMPRESSÃO PARA GARANTIR A VELOCIDADE DO RADAR EM DISPOSITIVOS MÓVEIS.
                                </p>
                            </div>
                        </div>
                    </div>

                </form>

                <footer className="text-center opacity-10 pt-20">
                    <p className="text-[10px] font-black uppercase tracking-[2em]">6BANNERSOLUTION ENGINE // TIM UNITY</p>
                </footer>
            </div>
        </MainLayout>
    );
}